angular.module('dnecom')
    .controller('marketingHubLicenseModalController', ["$scope", "$uibModalInstance", function ($scope, $uibModalInstance) {
        $scope.activateMarketingHub = function () {
            $uibModalInstance.close();
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }]); 